// DOTO theme main JS

(function($) {
  $(window).load(function(){
    
    // mobile variables
    var mobile = {
      isMobile : false,
      portfolioItemOffset : 0,
      detailsHeight : 0,
      portfolioItemHeight : 0,
      textScrollerTolerance: 0
    };
    var tablet = {
      isTablet : false,
      portfolioItemOffset : 0,
      detailsHeight : 0,
      portfolioItemHeight : 0,
      textScrollerTolerance: 0
    };
    var desktop = {
      isDesktop : false,
      detailsHeight: 0,
      textScrollerTolerance: 0
    };
    if ($(window).width() <= 480) {
      mobile.isMobile = true;
      mobile.detailsHeight = - $('.js-portfolio-item').height();
      mobile.portfolioItemHeight = $('.js-portfolio-item').height() + 1;
      mobile.textScrollerTolerance = 60;
    }
    else if ($(window).width() >= 481 && $(window).width() <= 800) {
      tablet.isTablet = true;
      tablet.detailsHeight = $('.js-portfolio-item').height();
      tablet.portfolioItemHeight = $('.js-portfolio-item').height() + 1;
      tablet.textScrollerTolerance = 60;
    }
    else {
      // desktop variables
      desktop.isDesktop = true;
      desktop.detailsHeight = - $('.js-portfolio-item').height();
      desktop.textScrollerTolerance = 120;
    }
    
    
    // close menu item
    function closeMenuItem() {
      $('.js-ajax-page-container-wrapper').animate({opacity: 0.001}, 500, function() {
        $('.menu_item').animate({'marginBottom': 0});
        $('.js-ajax-page-container').animate({'height': 0}, function() {
          $(this).empty();
          $('.js-ajax-page-container-wrapper').hide().css({'margin':0, 'display': 'none', 'opacity': 1});
        });
      });
    }
    
    // menu hover handling
    $('.js-menu-item-icon, .js-portfolio-item-icon').mouseover(function(){
        $(this).attr('src', $(this).data('icon-hover'));
    }).mouseout(function(icon){
        if (!$(this).hasClass('active')) {
          $(this).attr('src', $(this).data('icon'));
        }
    });
  
    // loader
    function loader($container, state) {
      state === 'on' ? $container.append('<div class="loader"/>') : $container.find('.loader').remove();
    }
    // clear active tile state
    function activeStateTilesCleanup() {
      $('.js-menu-item-icon, .js-portfolio-item-icon').each(function() {
        $(this).removeClass('active').attr('src', $(this).data('icon'));
      });
    }
  
    // handle active tile after click
    function setTileActive($elem) {
      // do cleanup after previous clicking
      activeStateTilesCleanup();
      //set current item active after click
      var $icon = $elem.find('.js-menu-item-icon, .js-portfolio-item-icon');
      $icon.addClass('active').attr('src', $icon.data('icon-hover'));
    }
    
    
    // display page using JS handler
    $('.js-portfolio-item-link').on('click', function(e) {
      e.preventDefault(); 
      if ($(this).find('.js-portfolio-item-icon').hasClass('active')) {
        $(this).parent().find('.js-close').click();
        $(this).find('.active').removeClass('active');
      }
      else {
        setTileActive($(this));
        if ($('.js-ajax-page-container').find('.portfolio-item-details').length > 0) {
          $('.js-ajax-page-container').animate({'marginBottom': 0});
        }
        var itemOffset = $(this).offset().top;
        var $thisPortfolioItem = $(this).parent();
        var widthBase = $('.portfolio-item').width();
        var contentsTopOffset = widthBase;
        var url = $(this).attr('href');
        var ajaxUrl = url + '?cfa=true';
        var siteWidth = $('.main_nav').innerWidth();
        var $container = $('<div class="portfolio-item-details" />');
        var scrollPage = function() {
          $('html, body').animate({ scrollTop: $thisPortfolioItem.offset().top + mobile.portfolioItemHeight }, 500);
        };
        if (mobile.isMobile && $(this).hasClass('js-menu-item-link')) {
          $('.js-mobile-menu-button').click();
          $thisPortfolioItem = $('.js-ajax-page-container');
          contentsTopOffset = 0;
          scrollPage = function() {
            $('html, body').animate({ scrollTop: 0 }, 500);
          };
        }
        var loadPortfolioItem = function() {
          $thisPortfolioItem.append($container).animate({'marginBottom': (widthBase * 4) + mobile.detailsHeight + tablet.detailsHeight}, 500);
          var containerOffset = $thisPortfolioItem.offset().left;
          $container
            .height(0)
            .width(siteWidth)
            .css({'top': contentsTopOffset, 'left': - containerOffset})
            .animate({'height': (widthBase * 4) + mobile.detailsHeight + tablet.detailsHeight}, 500, function() { //after animation is done - load content
              // turn on loader animation
              loader($container, 'on');
              if ($container.width() > $(window).width()) { // fix for browser scroll bar messing up the dimensions
                $container.width($(window).width());
                $container.css({'left': - $thisPortfolioItem.offset().left});
              }
              scrollPage();
              $(this).load(ajaxUrl, function() { // after content is loaded - load slider and scroller
                // turn off loader animation
                loader($container, 'off');
                // reset all bottom margins except current item
                $('.portfolio-item').not($thisPortfolioItem).css('marginBottom', 0);
                // fade contents in
                $container.find('.slider').animate({'opacity': 1}, 500);
                // load swiper slider
                var swiper = new Swiper('.js-swiper-portfolio', {
                  pagination: '.swiper-pagination',
                  paginationClickable: true,
                  nextButton: '.js-portfolio-swiper-button-next',
                  prevButton: '.js-portfolio-swiper-button-prev',
                  spaceBetween: 30,
                  followFinger: true,
                  shortSwipes: true,
                  longSwipes: true,
                  threshold: 100
                  
                });
                 
                // set page contents container height to fit details container height
                $('.js-page-content').height($('.portfolio-item-details').height());
                // set image height to fit 100% container height
                if (desktop.isDesktop) $container.find('.swiper-image').height($container.height()).width($container.height());
                // append close button
                $container.append($('<div class="close-button js-close"/>'));
                // close portfolio details on close click
                $('.portfolio-item-details .js-close').on('click', function() { 
                  activeStateTilesCleanup();    
                  $(this).remove();
                  $('.portfolio-item-details').animate({opacity: 0.001}, 500, function() {
                    $('.portfolio-item-details').remove();
                    $('.portfolio-item, .menu_item, .js-ajax-page-container').animate({'marginBottom': 0});
                  });
                });
                // set text container height to fit base height of one square(portfolio item)
                if (mobile.isMobile || tablet.isTablet) $container.find('.js-page-content').height(widthBase - 15);
                
                // load content scroller function
                var loadScroller = function(type) {
                  if (type === 'fullWidth') {
                    $('.swiper-slide').each(function() {
                      if ($(this).find('.js-content-scroller').height() + mobile.textScrollerTolerance + tablet.textScrollerTolerance + desktop.textScrollerTolerance > $(this).find('.js-page-content').height()) {
                        $(this).find('.content-scroller').removeClass('no-scroller').simplyScroll({
                          customClass:'vert',
                          orientation:'vertical',
                          auto: false,
                          speed: 10
                        });
                      }
                    });
                  }
                  else {
                    if ($('.js-content-scroller').height() + mobile.textScrollerTolerance + tablet.textScrollerTolerance + desktop.textScrollerTolerance > $('.js-page-content').height()  ) {
                      $('.content-scroller').removeClass('no-scroller').simplyScroll({
                        customClass:'vert',
                        orientation:'vertical',
                        auto: false,
                        speed: 10			
                      });
                    }
                  }
                };
                // set image height to fit 100% container height
                if (desktop.isDesktop) $container.find('.swiper-image').height($container.height()).width($container.height());
                // set text container height to fit base height of one square(portfolio item)
                if (mobile.isMobile || tablet.isTablet) $container.find('.js-page-content').height(widthBase - 15);
                // detect what kind of content scroller to load
                $('.js-slider').hasClass('js-fw') ? loadScroller('fullWidth') : loadScroller('regular');
      
              });
          });
        };
        if ($('.portfolio-item-details .slider').length > 0 || $('.portfolio-item-details .lang-switch').length > 0) {
          $activeItem = $('.portfolio-item-details').parent();
          $currentDetailsBox = $activeItem.find('.portfolio-item-details');
          if ($activeItem.offset().top === itemOffset) {
            $currentDetailsBox.remove();
            loadPortfolioItem();
          }
          else {
            $currentDetailsBox.animate({'opacity': 0}, 500);
            $('.portfolio-item').delay(500).animate({'marginBottom': 0}, 500);
            
            $currentDetailsBox.animate({'height': - widthBase * 4}, 500, function() {
              $currentDetailsBox.remove();
              loadPortfolioItem();
            });
          }
        }
        else {
          $('.portfolio-item-details').remove();
          loadPortfolioItem();
        }
      }
      
    });
  
    // categories filter
    $('.js-cat').on('click', function() {
      // clear all details boxes
      $('.portfolio-item-details').remove();
      $('.js-portfolio-item').css('margin', 0);
      // reset tiles state
      activeStateTilesCleanup();
      // change button state
      $('.js-cat').not($(this)).removeClass('active');
      $(this).addClass('active');
      // filter list
      var cat = $(this).data('cat');
      if (cat==='ALL') {
        $('.js-portfolio-item').fadeIn();
      }
      else {
        $('.js-portfolio-item').hide();
        $('.js-portfolio-item.' + cat).fadeIn();
      }
    });
    
    // mobile hamburger menu
    $('.js-mobile-menu-button').on('click', function() {
      $(this).toggleClass('open');
      $('.js-main-menu').toggleClass('open');
    });
    
    // fix for mobile browsers hiding the address bar
    $(window).resize(function(){
      if (mobile.isMobile) { $(".js-main-menu").height($(window).height()); }
    });
    
    // after all is loaded make sure page is scrolled to top
    $('html,body').scrollTop(0);
  });
}(jQuery));


